export default "__VITE_ASSET__cBtcNn$p__"